export default () => {

    const triggers = document.querySelectorAll(".js-modal-trigger");

    if (!triggers.length) return;
  
    triggers.forEach((trigger) => {
      const modalId = trigger.getAttribute("data-modal-id");
      const modalWrapper = document.getElementById(modalId);
  
      // Ensure modal exists and has correct class
      if (!modalWrapper || !modalWrapper.classList.contains("js-modal")) return;
  
      const dialog = modalWrapper.querySelector('[role="dialog"]');
      const closeButton = modalWrapper.querySelector(".modal-close");
      let previouslyFocusedElement = null;
  
      const focusableSelectors = [
        'a[href]',
        'area[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'button:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
      ];
  
      const getFocusableElements = () =>
        dialog.querySelectorAll(focusableSelectors.join(","));
  
      const trapFocus = (e) => {
        const focusableElements = getFocusableElements();
        const first = focusableElements[0];
        const last = focusableElements[focusableElements.length - 1];
  
        if (e.key === "Tab") {
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        } else if (e.key === "Escape") {
          closeModal();
        }
      };
  
      const openModal = () => {
        console.log('%cfrontend/stewart-title/js/components/Modal/initModal.js:49 object', 'color: #007acc;', "click");
        previouslyFocusedElement = document.activeElement;
  
        modalWrapper.classList.remove("dialog_hidden");
        modalWrapper.setAttribute("aria-hidden", "false");
  
        const focusable = getFocusableElements();
        if (focusable.length) focusable[0].focus();
  
        document.addEventListener("keydown", trapFocus);
      };
  
      const closeModal = () => {
        modalWrapper.classList.add("dialog_hidden");
        modalWrapper.setAttribute("aria-hidden", "true");
  
        document.removeEventListener("keydown", trapFocus);
        if (previouslyFocusedElement) previouslyFocusedElement.focus();
      };
  
      // Open on trigger click
      trigger.addEventListener("click", openModal);
  
      // Close on button click
      closeButton?.addEventListener("click", closeModal);
    });
  }
  